module.exports = __webpack_public_path__ + "img/y_p2_jianzhuwu.61771d25.svg";